__turbopack_context__.v({
  "body": "GecrYW_body",
  "body__content": "GecrYW_body__content",
  "body__content--can-play": "GecrYW_body__content--can-play",
  "body__content--placeholder": "GecrYW_body__content--placeholder",
  "card": "GecrYW_card",
  "overlay": "GecrYW_overlay",
  "overlay__content": "GecrYW_overlay__content",
  "shimmer": "GecrYW_shimmer",
  "text-bar-sweep": "GecrYW_text-bar-sweep",
  "title": "GecrYW_title",
  "title--placeholder": "GecrYW_title--placeholder",
});
